<template>
  <div class="hello">

    <div class="container">

      <div class="containerInner">

        <div class="columnLeft">
        </div>

        <div class="columnCenter">

          <h1>Digitalt perspektiv</h1>

          <p>
            På denna webbplats utforskar vi olika digitala ingångar i romaner och andra kulturella verk.
          </p>

          <h2>Fokus</h2>
          <div v-for="object in objects">
            <router-link :to="'fokus/' + object.route">{{object.readable}}</router-link>
          </div>

        </div>

        <div class="columnRight">
        </div>

      </div>

    </div>



    <!--ObjectTemplate :object="objects[0]"></ObjectTemplate-->

  </div>
</template>

<script>

import DJLanding from '@/components/objects/drottningensjuvelsmycke/DJLanding'

export default {
  components: {
  },
  data () {
    return {
      objects: [
        DJLanding
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .container{
    margin-bottom: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue